module.exports = {"aspectRatio":1.0666666666666667}